import { useLocalSearchParams } from 'expo-router';
import { loginModuleQuery, useModule } from 'system/structure-modules';

export default function LoginTokenRedirectScreen() {
    const { TokenRedirectScreen } = useModule(loginModuleQuery);
    const { provider1, token1 } = useLocalSearchParams<'/[siloKey]/login/one/tokenRedirect', { provider1: string; token1: string }>();
    return <TokenRedirectScreen provider={provider1} token={token1} />;
}
